import { selectableStreamThemes, type StreamEffectStyle } from '@ffs-studio/protocol';

/** Discovery only; usable by both dashboard entry points without importing legacy UI. */
export const STREAM_STYLE_OPTIONS = selectableStreamThemes().map((theme) => ({
  style: theme.id,
  label: theme.displayName,
}));
export const STREAM_STYLE_IDS = STREAM_STYLE_OPTIONS.map((theme) => theme.style);
export const STREAM_STYLE_LABELS = streamStyleRecord(
  (id) => STREAM_STYLE_OPTIONS.find((theme) => theme.style === id)!.label,
);

export function streamStyleRecord<T>(
  value: (id: StreamEffectStyle) => T,
): Record<StreamEffectStyle, T> {
  return Object.fromEntries(STREAM_STYLE_IDS.map((id) => [id, value(id)])) as Record<
    StreamEffectStyle,
    T
  >;
}

// Preserve the existing label on the two older dashboard surfaces.
export const LEGACY_STREAM_STYLE_OPTIONS = STREAM_STYLE_OPTIONS.map((theme) => ({
  ...theme,
  label: theme.style === 'win98' ? 'Windows 98' : theme.label,
}));
